var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Attorney"}},[_c('contact-selector',{attrs:{"name_prefix":"attorney","available_contacts":_vm.available_contacts,"contact_type":"buyer_attorney","value":{
            contact_id: _vm.attorney.contact_id,
            name: _vm.attorney.attorney_name,
            email: _vm.attorney.attorney_email,
            phone: _vm.attorney.attorney_phone,
        },"read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }